import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
};

export const drawerSlice = createSlice({
  name: "drawerReducer",
  initialState,
  reducers: {
    setDrawerList: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setDrawerList } = drawerSlice.actions;

export default drawerSlice.reducer;
